import { GridColDef } from "@mui/x-data-grid";
import { IconButton } from "@mui/material";
import dataUtils from "../../../../../../common/utils/dataUtils";
import DynamicIcon from "../../../../../../components/global/DynamicIcon";
import ItemStatus from "../../../../../../common/components/item_status";
import dayjs from "dayjs";

/**
 * GenerateObrasColumnDefinition
 */

type Props = {
  onActionEditar: (idManutencaoEquipObra: number | null, openState: boolean) => void;
  onActionDeletar: (idManutencaoEquipObra: number | null, openState: boolean) => void;
};

export const GenerateControleColumnDefinition = ({
  onActionEditar,
  onActionDeletar

}: Props): GridColDef[] => {

  const computeItemStatusTitle = (status: boolean) => {
    switch (status) {
      case false:
        return "Próprio";
      case true:
        return "Alugado";
      default:
        return "?";
    }
  };

  const computeItemStatusColor = (status: boolean) => {
    switch (status) {
      case false:
        return "green";
      case true:
        return "red";
      default:
        return "blue";
    }
  };

  const computeItemStatusDescription = (status: boolean) => {
    switch (status) {
      case false:
        return "Equipamento Próprio";
      case true:
        return "Equipamento Alugado";
      default:
        return "?";
    }
  };

  return [
    {
      field: "descricao",
      filterable: false,
      headerName: "Equipamento",
      flex: 3,
      minWidth: 150,
      sortable: false,
      renderCell: (params) => (
        <div className="w-full h-full flex justify-center items-center text-center text-xs">
          {params.value}
        </div>
      ),
    },
    {
      field: "status",
      filterable: false,
      headerName: "Status",
      minWidth: 65,
      width: 65,
      sortable: false,
      renderCell: (params) => (
        <div className="w-full h-full flex justify-center items-center text-xs">
          <ItemStatus
            size="autowidth"
            textSize="extraSmall"
            title={computeItemStatusTitle(params.value)}
            color={computeItemStatusColor(params.value)}
            description={computeItemStatusDescription(params.value)} />
        </div>
      )
    },
    {
      field: "dataPrevDevolucao",
      filterable: false,
      headerName: "Data Prevista Devolução",
      minWidth: 85,
      width: 85,
      sortable: false,
      renderCell: (params) => (
        <div className="w-full h-full flex justify-center items-center text-center text-xs">
          {
            params.value !== null && params.value !== undefined
              ? dayjs.utc(params.value).local().format('DD/MM/YYYY')
              : '-'
          }
        </div>
      ),
    },
    {
      field: "dataManutencao",
      filterable: false,
      headerName: "	Data Vistoria",
      minWidth: 85,
      width: 85,
      sortable: false,
      renderCell: (params) => (
        <div className="w-full h-full flex justify-center items-center text-center text-xs">
          {
            params.value !== null && params.value !== undefined
              ? dayjs.utc(params.value).local().format('DD/MM/YYYY')
              : '-'
          }
        </div>
      ),
    },
    {
      field: "dataProxManutencao",
      filterable: false,
      headerName: "Próxima Vistoria",
      minWidth: 85,
      width: 85,
      sortable: false,
      renderCell: (params) => (
        <div className="w-full h-full flex justify-center items-center text-center text-xs">
          {
            params.value !== null && params.value !== undefined
              ? dayjs.utc(params.value).local().format('DD/MM/YYYY')
              : '-'
          }
        </div>
      ),
    },
    {
      field: "parteEletrica",
      filterable: false,
      headerName: "Parte Elétrica",
      flex: 1,
      minWidth: 50,
      sortable: false,
      renderCell: (params) => (
        <div className="w-full h-full flex justify-center items-center text-center text-xs">
          {params.value}
        </div>
      ),
    },
    {
      field: "parteMecanica",
      filterable: false,
      headerName: "Parte Mecânica",
      flex: 1,
      minWidth: 50,
      sortable: false,
      renderCell: (params) => (
        <div className="w-full h-full flex justify-center items-center text-center text-xs">
          {params.value}
        </div>
      ),
    },
    {
      field: "lubrificacao",
      filterable: false,
      headerName: "Lubrificação",
      flex: 1,
      minWidth: 50,
      sortable: false,
      renderCell: (params) => (
        <div className="w-full h-full flex justify-center items-center text-center text-xs">
          {params.value}
        </div>
      ),
    },
    {
      field: "limpeza",
      filterable: false,
      headerName: "Limpeza",
      flex: 1,
      minWidth: 50,
      sortable: false,
      renderCell: (params) => (
        <div className="w-full h-full flex justify-center items-center text-center text-xs">
          {params.value}
        </div>
      ),
    },
    {
      field: "observacao",
      filterable: false,
      headerName: "Observação",
      flex: 2,
      minWidth: 150,
      sortable: false,
      renderCell: (params) => (
        <div className="w-full h-full flex justify-center items-center text-center text-xs">
          {params.value}
        </div>
      ),
    },
    {
      field: "outros1",
      filterable: false,
      headerName: "Outros1",
      flex: 1,
      minWidth: 50,
      sortable: false,
      renderCell: (params) => (
        <div className="w-full h-full flex justify-center items-center text-center text-xs">
          {params.value}
        </div>
      ),
    },
    {
      field: "outros2",
      filterable: false,
      headerName: "Outros2",
      flex: 1,
      minWidth: 50,
      sortable: false,
      renderCell: (params) => (
        <div className="w-full h-full flex justify-center items-center text-center text-xs">
          {params.value}
        </div>
      ),
    },
    {
      field: "idManutencaoEquipObra",
      headerName: "Ações",
      sortable: false,
      filterable: false,
      width: 90,
      renderCell: (params) => (
        <div className="flex items-center justify-center w-full h-full gap-1">
          <IconButton onClick={() => onActionEditar(params.row.idManutencaoEquipObra, true)}>
            <DynamicIcon nameIcon="EditRounded" size={25} className="dark:text-white text-primary-green" />
          </IconButton>

          <IconButton onClick={() => onActionDeletar(params.row.idManutencaoEquipObra, true)}>
            <DynamicIcon nameIcon="DeleteForeverRounded" size={25} className="text-red-500" />
          </IconButton>
        </div>
      ),
    },
  ];
};
